module.exports = __webpack_public_path__ + "static/media/scroll3_2.e836a7d6.png";